import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const homeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) {
    // If authenticated, redirect from Home to Chat
    return router.parseUrl('/chat');
  }
  
  // If not authenticated, allow access to Home
  return true;
};
